// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_container__eDijo {
  width: 100%;
}

.form_inputContents__9Jeze {
  display: flex;
  flex-direction: column;
}

.form_inputContainer__R\\+u9d {
  width: 100%;
}

.form_inputContainerRed__RwaRJ {
  width: 100%;
}

.form_inputContainer__R\\+u9d input,
.form_inputContainer__R\\+u9d textarea {
  box-sizing: border-box;
  width: 100%;
  padding: 0.4em;
  margin: auto;
  text-align: center;
  font-size: 1.2em;
  border: none;
  border-radius: 0.2em;
  background: #dfe6e9;
}

.form_inputContainerRed__RwaRJ input,
.form_inputContainer__R\\+u9d textarea {
  box-sizing: border-box;
  width: 100%;
  padding: 0.4em;
  margin: auto;
  text-align: center;
  font-size: 1.2em;
  border: none;
  border-radius: 0.2em;
  /* background : #ff7675; */
}

.form_inputContainer__R\\+u9d input[type='date'] {
  height: 1.8em;
  color: #055437;
}
.form_inputContainer__R\\+u9d label {
  padding-top: 0.4em;
  font-size: 1.3em;
  font-weight: 500;
  /* color : #00b894; */
  color: #055437;
}
.form_buttonContainer__QFnEa {
  display: flex;
  margin: 0.3em 0;
  width: 100%;
}
.form_buttonContainer__QFnEa button {
  width: 15em;
  padding: 0.4em 1em;
  margin: auto;
  text-align: center;
  font-size: 1.2em;
  border: none;
  border-radius: 0.2em;
  width: 100%;
  transition-duration: 200ms;
  font-family: 'IBM Plex Sans', sans-serif;
  /* background-color : #22835f; */
}
.form_buttonContainer__QFnEa button * {
  padding: 0 0.4em;
}

.form_title__rtZbl {
  text-align: left;
  font-size: 1.3em;
  /* color : #00b894; */
  color: #055437;
  font-weight: 500;
  margin-bottom: 0.2em;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
`, "",{"version":3,"sources":["webpack://./src/components/Form/form.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,0BAA0B;EAC1B,wCAAwC;EACxC,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".container {\n  width: 100%;\n}\n\n.inputContents {\n  display: flex;\n  flex-direction: column;\n}\n\n.inputContainer {\n  width: 100%;\n}\n\n.inputContainerRed {\n  width: 100%;\n}\n\n.inputContainer input,\n.inputContainer textarea {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0.4em;\n  margin: auto;\n  text-align: center;\n  font-size: 1.2em;\n  border: none;\n  border-radius: 0.2em;\n  background: #dfe6e9;\n}\n\n.inputContainerRed input,\n.inputContainer textarea {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0.4em;\n  margin: auto;\n  text-align: center;\n  font-size: 1.2em;\n  border: none;\n  border-radius: 0.2em;\n  /* background : #ff7675; */\n}\n\n.inputContainer input[type='date'] {\n  height: 1.8em;\n  color: #055437;\n}\n.inputContainer label {\n  padding-top: 0.4em;\n  font-size: 1.3em;\n  font-weight: 500;\n  /* color : #00b894; */\n  color: #055437;\n}\n.buttonContainer {\n  display: flex;\n  margin: 0.3em 0;\n  width: 100%;\n}\n.buttonContainer button {\n  width: 15em;\n  padding: 0.4em 1em;\n  margin: auto;\n  text-align: center;\n  font-size: 1.2em;\n  border: none;\n  border-radius: 0.2em;\n  width: 100%;\n  transition-duration: 200ms;\n  font-family: 'IBM Plex Sans', sans-serif;\n  /* background-color : #22835f; */\n}\n.buttonContainer button * {\n  padding: 0 0.4em;\n}\n\n.title {\n  text-align: left;\n  font-size: 1.3em;\n  /* color : #00b894; */\n  color: #055437;\n  font-weight: 500;\n  margin-bottom: 0.2em;\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `form_container__eDijo`,
	"inputContents": `form_inputContents__9Jeze`,
	"inputContainer": `form_inputContainer__R+u9d`,
	"inputContainerRed": `form_inputContainerRed__RwaRJ`,
	"buttonContainer": `form_buttonContainer__QFnEa`,
	"title": `form_title__rtZbl`
};
export default ___CSS_LOADER_EXPORT___;
